import { combineReducers, configureStore } from '@reduxjs/toolkit';
import userDetailsSlice from './slices/userDetailsSlice';
import themeReducer from './slices/themeSlice';
import tagReducer from './slices/tagSlice';
import languageReducer from './slices/languageSlice';
import contactCardReducer from './slices/contactCardSlice';
import yearReducer from './slices/selectedYearSlice';
import viewReducer from './slices/viewSlice';
import viewHatvReducer from './slices/HatvViewSlice';
import apDetailsReducer from './slices/apslice';
import sidebarExpansionReducer from './slices/sidebarExpansionSlice';
import viewAboAssignmentReducer from './slices/aboAssignmentViewSlice';
import { aboBackgroundDetailsAPI } from './services/aboBackgroundDetailsAPI';
import { aboContactCardDetailsAPI } from './services/aboContactCardDetailsAPI';
import successionPlanReducer from './slices/successionDocsSlice';
import { successionPlanDocsListAPI } from './services/successionPlanAPI';
import { actionPlanDocsListAPI } from './services/actionPlansDocumentAPI';
import { aboInfoBannerDetailsAPI } from './services/aboInfoBannerDetailsAPI';
import { optionMasterAPI } from './services/optionMasterAPI';
import { goalsAPI } from './services/goalsAPI';
import { progressNotesAPI } from './services/progressNotesAPI';
import { growthPlanNotesAPI } from './services/growthPlanNotesAPI';
import { apNotesAPI } from './services/apNotesAPI';
import { myAccountListAPI } from './services/myAccountAPI';
import { globalSearchAPI } from './services/globalSearchAPI';
import { legAnalysisAPI } from './services/legAnalysisAPI';
import { customizeViewAPI } from './services/customizeViewAPI';
import { apInformationDocsListAPI } from './services/apInformationdocumentAPI';
import { apDropdownAPI } from './services/apDropdownAPI';
import { apBackgroundDetailsAPI } from './services/apBackgroundDetailsAPI';
import { apSubheaderAPI } from './services/apSubHeaderAPI';
import { kpiSettingsByTypeAPI } from './services/kpiSettingsByTypeAPI';
import { businessPerformanceAPI } from './services/businessPerformaceAPI';
import { agcAIAPI } from './services/agcAIAPI';
import customViewKpiListSlice from './slices/customisedViewKpiList';
import closingMonthReducer from './slices/businessPerformanceClosingMonthSlice';
import { followUpQuestionsAPI } from './services/followUpQuestionsAPI';
import { HATVCasesAPI } from './services/hatvCasesAPI';
import { reportBuilderABOListAPI } from './services/reportBuilderAPI';
import { aboQualitativeAPI } from './services/aboQualitativeAPI';
import { AwardHistoryAPI } from './services/awardHistoryAPI';
import { HATVAwardApprovalApi } from './services/hatvAwardApprovalAPI';
import { HATVAwardDetailsAPI } from './services/hatvAwardDetailsAPI';
import { hatvNotesAPI } from './services/hatvQMonthNotesAPI';
import { hatvDocumentListAPI } from './services/hatvDocumentAPI';
import { hatvAboStatisticAPI } from './services/hatvAboStatisticAPI';
import { customizeHatvViewAPI } from './services/customizeViewHatvAPI';
import { hatvQmonthUplineImpactAPI } from './services/hatvQmonthUplineImpactAPI';
import { hatvQmonthDetailsAPI } from './services/hatvQmonthDetailsAPI';
import { hatvKPIAPI } from './services/hatvKPIAPI';
import { aboFilterAPI } from './services/aboFilterAPI';
import { customizeViewAboAssignmentAPI } from './services/customiseViewAboAssignmentAPI';

import { aboAssignmentListAPI } from './services/aboAssignmentAPI';
import currencyReducer from './slices/CurrencyCodeSlice';
import { goalActionsAPI } from './services/goalActionsAPI';
import { growthPlanDocumentAPI } from './services/growthPlanDocumentAPI';
import { goalMetricsAPI } from './services/goalMetricAPI';
import { leaderProfileRecognitionAPI } from './services/leaderProfileRecognitionAPI';
import { leaderFoundationalInfoAPI } from './services/LeaderFoundationalInfoAPI';
import { leaderProfileBusinessApproachAPI } from './services/leaderProfileBusinessApproachAPI';
import { generalInformationAPI } from './services/generalInformation';
import { leaderProfileExportAPI } from './services/leaderProfileExportAPI';
import { leaderBusinessBackgroundAPI } from './services/leaderBusinessBackgroundAPI';
import { leaderMultipleBusinessesAPI } from './services/leaderMultipleBusinessesAPI';

const combinedReducer = combineReducers({
  userDetails: userDetailsSlice,
  theme: themeReducer,
  tag: tagReducer,
  currency: currencyReducer,
  contactCard: contactCardReducer,
  selectedYear: yearReducer,
  successionPlanDoc: successionPlanReducer,
  language: languageReducer,
  viewIdDetails: viewReducer,
  viewIdDetailsHatv: viewHatvReducer,
  viewIdDetailsAboAssignment: viewAboAssignmentReducer,
  apDetails: apDetailsReducer,
  businessPerformanceClosingMonth: closingMonthReducer,
  customViewConfigKPIList: customViewKpiListSlice,
  sideNavExpansion: sidebarExpansionReducer,
  // `rtk-query` api reducers
  [aboBackgroundDetailsAPI.reducerPath]: aboBackgroundDetailsAPI.reducer,
  [aboContactCardDetailsAPI.reducerPath]: aboContactCardDetailsAPI.reducer,
  [successionPlanDocsListAPI.reducerPath]: successionPlanDocsListAPI.reducer,
  [aboInfoBannerDetailsAPI.reducerPath]: aboInfoBannerDetailsAPI.reducer,
  [optionMasterAPI.reducerPath]: optionMasterAPI.reducer,
  [actionPlanDocsListAPI.reducerPath]: actionPlanDocsListAPI.reducer,
  [goalsAPI.reducerPath]: goalsAPI.reducer,
  [progressNotesAPI.reducerPath]: progressNotesAPI.reducer,
  [growthPlanNotesAPI.reducerPath]: growthPlanNotesAPI.reducer,
  [apNotesAPI.reducerPath]: apNotesAPI.reducer,
  [myAccountListAPI.reducerPath]: myAccountListAPI.reducer,
  [globalSearchAPI.reducerPath]: globalSearchAPI.reducer,
  [legAnalysisAPI.reducerPath]: legAnalysisAPI.reducer,
  [customizeViewAPI.reducerPath]: customizeViewAPI.reducer,
  [apInformationDocsListAPI.reducerPath]: apInformationDocsListAPI.reducer,
  [apDropdownAPI.reducerPath]: apDropdownAPI.reducer,
  [apBackgroundDetailsAPI.reducerPath]: apBackgroundDetailsAPI.reducer,
  [apSubheaderAPI.reducerPath]: apSubheaderAPI.reducer,
  [kpiSettingsByTypeAPI.reducerPath]: kpiSettingsByTypeAPI.reducer,
  [businessPerformanceAPI.reducerPath]: businessPerformanceAPI.reducer,
  [followUpQuestionsAPI.reducerPath]: followUpQuestionsAPI.reducer,
  [agcAIAPI.reducerPath]: agcAIAPI.reducer,
  [HATVCasesAPI.reducerPath]: HATVCasesAPI.reducer,
  [reportBuilderABOListAPI.reducerPath]: reportBuilderABOListAPI.reducer,
  [aboQualitativeAPI.reducerPath]: aboQualitativeAPI.reducer,
  [AwardHistoryAPI.reducerPath]: AwardHistoryAPI.reducer,
  [HATVAwardApprovalApi.reducerPath]: HATVAwardApprovalApi.reducer,
  [HATVAwardDetailsAPI.reducerPath]: HATVAwardDetailsAPI.reducer,
  [hatvNotesAPI.reducerPath]: hatvNotesAPI.reducer,
  [hatvKPIAPI.reducerPath]: hatvKPIAPI.reducer,
  [hatvDocumentListAPI.reducerPath]: hatvDocumentListAPI.reducer,
  [hatvAboStatisticAPI.reducerPath]: hatvAboStatisticAPI.reducer,
  [customizeHatvViewAPI.reducerPath]: customizeHatvViewAPI.reducer,
  [hatvQmonthUplineImpactAPI.reducerPath]: hatvQmonthUplineImpactAPI.reducer,
  [hatvQmonthDetailsAPI.reducerPath]: hatvQmonthDetailsAPI.reducer,
  [aboFilterAPI.reducerPath]: aboFilterAPI.reducer,
  [aboAssignmentListAPI.reducerPath]: aboAssignmentListAPI.reducer,
  [customizeViewAboAssignmentAPI.reducerPath]: customizeViewAboAssignmentAPI.reducer,
  [goalActionsAPI.reducerPath]: goalActionsAPI.reducer,
  [goalMetricsAPI.reducerPath]: goalMetricsAPI.reducer,
  [growthPlanDocumentAPI.reducerPath]: growthPlanDocumentAPI.reducer,
  [leaderProfileRecognitionAPI.reducerPath]: leaderProfileRecognitionAPI.reducer,
  [leaderProfileExportAPI.reducerPath]: leaderProfileExportAPI.reducer,
  [leaderFoundationalInfoAPI.reducerPath]: leaderFoundationalInfoAPI.reducer,
  [leaderProfileBusinessApproachAPI.reducerPath]: leaderProfileBusinessApproachAPI.reducer,
  [generalInformationAPI.reducerPath]: generalInformationAPI.reducer,
  [leaderBusinessBackgroundAPI.reducerPath]: leaderBusinessBackgroundAPI.reducer,
  [leaderMultipleBusinessesAPI.reducerPath]: leaderMultipleBusinessesAPI.reducer,
});

const masterReducer = (state: any, action: any) => {
  return combinedReducer(state, action);
};

export const store = configureStore({
  reducer: masterReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(aboContactCardDetailsAPI.middleware)
      .concat(aboBackgroundDetailsAPI.middleware)
      .concat(successionPlanDocsListAPI.middleware)
      .concat(aboInfoBannerDetailsAPI.middleware)
      .concat(optionMasterAPI.middleware)
      .concat(actionPlanDocsListAPI.middleware)
      .concat(goalsAPI.middleware)
      .concat(progressNotesAPI.middleware)
      .concat(growthPlanNotesAPI.middleware)
      .concat(apNotesAPI.middleware)
      .concat(myAccountListAPI.middleware)
      .concat(globalSearchAPI.middleware)
      .concat(legAnalysisAPI.middleware)
      .concat(customizeViewAPI.middleware)
      .concat(apInformationDocsListAPI.middleware)
      .concat(apDropdownAPI.middleware)
      .concat(apBackgroundDetailsAPI.middleware)
      .concat(apSubheaderAPI.middleware)
      .concat(kpiSettingsByTypeAPI.middleware)
      .concat(businessPerformanceAPI.middleware)
      .concat(followUpQuestionsAPI.middleware)
      .concat(agcAIAPI.middleware)
      .concat(HATVCasesAPI.middleware)
      .concat(reportBuilderABOListAPI.middleware)
      .concat(aboQualitativeAPI.middleware)
      .concat(AwardHistoryAPI.middleware)
      .concat(HATVAwardApprovalApi.middleware)
      .concat(HATVAwardDetailsAPI.middleware)
      .concat(hatvNotesAPI.middleware)
      .concat(hatvKPIAPI.middleware)
      .concat(hatvDocumentListAPI.middleware)
      .concat(hatvAboStatisticAPI.middleware)
      .concat(customizeHatvViewAPI.middleware)
      .concat(hatvQmonthUplineImpactAPI.middleware)
      .concat(hatvQmonthDetailsAPI.middleware)
      .concat(aboFilterAPI.middleware)
      .concat(aboAssignmentListAPI.middleware)
      .concat(customizeViewAboAssignmentAPI.middleware)
      .concat(goalActionsAPI.middleware)
      .concat(goalMetricsAPI.middleware)
      .concat(growthPlanDocumentAPI.middleware)
      .concat(leaderProfileRecognitionAPI.middleware)
      .concat(leaderProfileExportAPI.middleware)
      .concat(leaderFoundationalInfoAPI.middleware)
      .concat(leaderProfileBusinessApproachAPI.middleware)
      .concat(generalInformationAPI.middleware)
      .concat(leaderBusinessBackgroundAPI.middleware)
      .concat(leaderMultipleBusinessesAPI.middleware),
});

export const makeStore = () => store;

export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState}
export type AppDispatch = typeof store.dispatch;
